module.exports = __webpack_public_path__ + "img/quizzz-3.ab7a9e26.jpg";